module.exports = __webpack_public_path__ + "img/CODINAFRICA.8186aa5a.png";